module.exports = __webpack_public_path__ + "img/img_userCasePopupContent_profile1.9b37361f.png";